const { datadogLogs } = await import('@datadog/browser-logs');
const { datadogRum } = await import('@datadog/browser-rum');

// All of our services use prod.
const env = import.meta.env.MODE === 'production' ? 'prod' : import.meta.env.MODE;

export const initRum = () => {
  datadogRum.init({
    applicationId: import.meta.env.VITE_DD_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'otter',
    env,
    allowedTracingUrls: [/https:\/\/.*\.api.seaworld\.com/],
    version: import.meta.env.VITE_BUILD_NUMBER,

    sessionSampleRate: +import.meta.env.VITE_DD_SESSION_SAMPLE_RATE,
    sessionReplaySampleRate: +import.meta.env.VITE_DD_REPLAY_SESSION_SAMPLE_RATE,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',

    enableExperimentalFeatures: ['feature_flags'],
  });
};

export const initLogs = () => {
  datadogLogs.init({
    clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'otter',
    env,
    version: import.meta.env.VITE_BUILD_NUMBER,

    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['warn', 'error'],
    sessionSampleRate: +import.meta.env.VITE_DD_SESSION_SAMPLE_RATE,
  });
};
